import { ALL_COMPETENCE_CENTER } from "../../constants/Dictionary";
import { PotentialMatrixFilters } from "../usePotentialMatrixFilters.hook";
import { usePracticeCompetenceData } from "./usePracticeCompetenceData.hook";

type useMatrixDownloadSubtitleProps = {
  filters: PotentialMatrixFilters;
};

const CC_NAMES_PER_LINE = 10;

export const useMatrixDownloadSubtitle = ({
  filters,
}: useMatrixDownloadSubtitleProps) => {
  const { practiceList, CCList } = usePracticeCompetenceData(filters);

  const practiceLabel = practiceList?.find(
    (item) => item.id === filters.practice[0],
  )?.name;

  const ccValue =
    filters.cc.length === 0
      ? ALL_COMPETENCE_CENTER
      : filters.cc
          .map((ccId) => CCList?.find((item) => item.id === ccId)?.name ?? ccId)
          .reduce<string[]>((lines, name, index) => {
            const lineIndex = Math.floor(index / CC_NAMES_PER_LINE);
            lines[lineIndex] = lines[lineIndex]
              ? `${lines[lineIndex]}, ${name}`
              : name;
            return lines;
          }, [])
          .join("\n");

  return { practiceLabel, ccValue };
};
